"use client";
import Image from "next/image";
import { usePathname, useRouter } from "next/navigation";
import React from "react";

const HomeLogo = ({ w = 130, h = 60 }) => {
  const router = useRouter();
  const pathName = usePathname();
  const homeNav = () => {
    if (pathName === "/en" || pathName === "/ar") {
      return;
    } else {
      router.push(`/${pathName?.split("/")[1]}`);
    }
  };
  return (
    <div onClick={homeNav} className="cursor-pointer">
      <Image
        src="/images/brand5.png"
        width={w}
        height={h}
        objectFit="contain"
        alt="logo"
        priority={true}
        className="hidden lg:block"
        unoptimized
      />
      <Image
        src="/images/brand5.png"
        width={90}
        height={30}
        objectFit="contain"
        alt="logo"
        priority={true}
        className="block lg:hidden"
        unoptimized
      />
    </div>
  );
};

export default HomeLogo;
